import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'

import VueApollo from 'vue-apollo'

import { BASE_URL } from '../service/ServiceURL'
import store from '../store/'
import router from '../router/'

const errorHandler = ({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.map(({ message, locations, path }) =>
      console.log(`%c [GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, 'color:white; background:blue; padding:4px; border-radius:4px; font-size:1em'))
  }

  if (networkError) {
    let { statusCode } = networkError
    console.log(`%c [Network error]: ${networkError}`, 'color:white; background:red; padding:4px; border-radius:4px; font-size:1em')
    if (statusCode && statusCode === 401) {
      store.commit('setUser', {})
      router.push('/login')
    }
  }
}

const httpLink = new HttpLink({
  uri: `${BASE_URL}/api/v2/arautos`
})

const authLink = setContext((_, { headers }) => {
  const token = store.state.user.token || ''
  return {
    headers: {
      ...headers,
      'x-access-token': token
    }
  }
})

const defaultOptions = {
  $query: {
    loadingKey: 'loading',
    fetchPolicy: 'network-only',
    errorPolicy: 'all'
  }
}

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache({ addTypename: false }),
  connectToDevTools: true
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
  defaultOptions,
  errorHandler
})

export default apolloProvider



// WEBPACK FOOTER //
// ./src/graphql/index.js